<template>
  <div class="page-container">
    <md-app md-mode="reveal">
      <md-app-toolbar class="md-primary">
        <Header :menuVisible="menuVisible" v-on:toggleMenu="toggleMenu"/>
      </md-app-toolbar>

      <md-app-drawer :md-active.sync="menuVisible">
        <Menu :menuVisible="menuVisible"/>
      </md-app-drawer>

      <md-app-content>
        <div>
            <md-dialog-confirm
                :md-active.sync="deleteConfirm"
                md-title="Confirmación"
                md-content="¿Desea elminar esta pregunta?"
                md-confirm-text="Borrar"
                md-cancel-text="Cancelar"
                @md-cancel="deleteConfirm = false"
                @md-confirm="onDeleteConfirm" />

            <md-content v-if="showDialog">
                <form novalidate class="md-layout" @submit.prevent="validateItem">
                <md-card class="md-layout-item">
                    <md-card-header>
                    <div class="md-title" v-if="!formForEdit">Nueva pregunta</div>
                    <div class="md-title" v-if="formForEdit">Modificar pregunta</div>
                    </md-card-header>

                    <md-card-content>
                        <md-field>
                            <label for="text">Texto</label>
                            <md-input name="text" id="text" v-model="form.text" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="movie">Estado</label>
                            <md-select name="status" id="status" v-model="form.status">
                                <md-option value="revision" :disabled="!acl.createsQuestions && !acl.modifiesQuestions">En revisión</md-option>
                                <md-option value="active" :disabled="!acl.aprovesQuestions">Activa</md-option>
                                <md-option value="suspended" :disabled="!acl.suspendsQuestions">Suspendida</md-option>
                            </md-select>
                        </md-field>

                        <md-field>
                            <label for="movie">Dificultad</label>
                            <md-select name="difficulty" id="difficulty" v-model="form.difficulty">
                                <md-option value="1">Fácil</md-option>
                                <md-option value="2">Normal</md-option>
                                <md-option value="3">Difícil</md-option>
                            </md-select>
                        </md-field>

                        <label for="movie">Etiquetas</label>
                        <vue-tags-input
                            v-model="tag"
                            :tags="form.tags"
                            @tags-changed="newTags => form.tags = newTags"
                            placeholder="Agregue una etiqueta..."/>

                        <md-field style="margin-top: 25px;">
                            <label for="correct">Respuesta correcta</label>
                            <md-input name="correct" id="correct" v-model="form.correct" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="incorrect_0">Respuesta incorrecta #1</label>
                            <md-input name="incorrect_0" id="incorrect_0" v-model="form.incorrect_0" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="incorrect_1">Respuesta incorrecta #2</label>
                            <md-input name="incorrect_1" id="incorrect_1" v-model="form.incorrect_1" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="incorrect_2">Respuesta incorrecta #3</label>
                            <md-input name="incorrect_2" id="incorrect_2" v-model="form.incorrect_2" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="incorrect_3">Respuesta incorrecta #4</label>
                            <md-input name="incorrect_3" id="incorrect_3" v-model="form.incorrect_3" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="incorrect_4">Respuesta incorrecta #5</label>
                            <md-input name="incorrect_4" id="incorrect_4" v-model="form.incorrect_4" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="incorrect_5">Respuesta incorrecta #6</label>
                            <md-input name="incorrect_5" id="incorrect_5" v-model="form.incorrect_5" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="incorrect_6">Respuesta incorrecta #7</label>
                            <md-input name="incorrect_6" id="incorrect_6" v-model="form.incorrect_6" :disabled="sending" />
                        </md-field>

                        <md-field>
                            <label for="incorrect_7">Respuesta incorrecta #8</label>
                            <md-input name="incorrect_7" id="incorrect_7" v-model="form.incorrect_7" :disabled="sending" />
                        </md-field>

                        <div class="md-subheading" style="margin-top: 40px;">Quests (Esta pregunta formará parte de las "Quests" seleccionadas)</div>
                        <ul style="padding:0px; margin:0px;">
                            <li v-for="q in availableQuests" v-bind:key="q.id" style="list-style:none;">
                                <md-checkbox v-model="form.quests" :value="q.id" class="md-primary">{{q.name}}</md-checkbox>
                            </li>
                        </ul>
                    </md-card-content>

                    <md-progress-bar md-mode="indeterminate" v-if="sending" />

                    <md-card-actions>
                    <md-button class="md-accent" @click="cancelForm()">Cancelar</md-button>
                    <md-button type="submit" class="md-primary" :disabled="sending">Guardar</md-button>
                    </md-card-actions>
                </md-card>

                </form>
            </md-content>

            <div class="loading" v-if="loading">
                Cargando...
            </div>

            <md-table v-model="questions" md-sort="name" md-sort-order="asc" v-if="!loading && !showDialog" md-card md-fixed-header>
                <md-table-toolbar>
                    <h1 class="md-title">Preguntas <span v-if="category.name">sobre <strong>{{ category.name }}</strong> ({{ category.qtyQuestions }})</span></h1>
                    <md-button class="md-fab md-primary" @click="showForm()" v-if="acl.createsQuestions">
                        <md-icon>add</md-icon>
                    </md-button>
                </md-table-toolbar>

                <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell md-label="Texto" md-sort-by="text">{{ item.text }}</md-table-cell>
                    <md-table-cell md-label="Dificultad" md-sort-by="difficulty">{{ difficultyNames[item.difficulty] }}</md-table-cell>
                    <md-table-cell md-label="Estado" md-sort-by="qtyQuestions">{{ (item.status == 'active') ? 'Activo' : (item.status == 'revision') ? 'En Revisión' : 'Suspendido' }}</md-table-cell>
                    <md-table-cell md-label="Quests" md-sort-by="quests">{{ item.quests.length }}</md-table-cell>
                    <md-table-cell class="actions-cell">
                        <md-button class="md-icon-button md-primary" @click="editItem(item)" v-if="acl.modifiesQuestions">
                            <md-icon>edit</md-icon>
                        </md-button>
                        <md-button class="md-icon-button md-accent" @click="deleteItem(item)" v-if="acl.deletesQuestions">
                            <md-icon>delete</md-icon>
                        </md-button>
                    </md-table-cell>
                </md-table-row>
            </md-table>
        </div>
      </md-app-content>
    </md-app>
  </div>
</template>

<style lang="scss" scoped>
  .md-app {
    border: 1px solid rgba(#000, .12);
  }
  .md-dialog {
    max-width: 768px;
  }
  .actions-cell {
    text-align: right;
  }
  .md-select-content {
    z-index: 9999;
  }
</style>

<script>
import Header from './Header.vue';
import Menu from './Menu.vue';
import firebase from 'firebase';
import {config} from '../helpers/apiConfig'
import {user} from '../helpers/user'
import axios from "axios";
import VueTagsInput from '@johmun/vue-tags-input';

export default {
    name: 'Questions',
    components: {
        Header, Menu, VueTagsInput
    },
    data: () => ({
        menuVisible: false,
        loading: false,
        deleteConfirm: false,
        deleteItemId: null,
        category: {},
        questions: [],
        availableQuests: [],
        showDialog: false,
        form: {
            category: null,
            text: null,
            status: null,
            difficulty: null,
            tags: [],
            correct: null,
            incorrect_0: null,
            incorrect_1: null,
            incorrect_2: null,
            incorrect_3: null,
            incorrect_4: null,
            incorrect_5: null,
            incorrect_6: null,
            incorrect_7: null,
            quests: []
        },
        difficultyNames: {
            '1': 'Fácil',
            '2': 'Normal',
            '3': 'Difícil',
        },
        tag: '',
        formForEdit: false,
        sending: false,
        lastUser: null,
        acl: {
            createsQuestions: false,
            modifiesQuestions: false,
            aprovesQuestions: false,
            suspendsQuestions: false,
            deletesQuestions: false
        }
    }),
    mounted() {
        firebase.auth().onAuthStateChanged((liuser) => {
            if (liuser) {
                console.log('User logged in, go ahead...');
                var that = this;
                user.init(firebase.auth().currentUser, () => {
                    that.fetchData();
                });
            } else {
                this.$router.push('/auth')
                console.log('User not logged in!');
            }
        });
    },
    watch: {
        // call again the method if the route changes
        '$route': 'fetchData'
    },
    methods: {
        toggleMenu () {
            this.menuVisible = !this.menuVisible
        },
        fetchData () {
            this.questions = [];
            this.loading = true;
            this.acl = {
                createsQuestions: user.hasPermission('createsQuestions'),
                modifiesQuestions: user.hasPermission('modifiesQuestions'),
                aprovesQuestions: user.hasPermission('aprovesQuestions'),
                suspendsQuestions: user.hasPermission('suspendsQuestions'),
                deletesQuestions: user.hasPermission('deletesQuestions')
            }
            //console.log('this.acl', this.acl);

            axios({ 
                "method": "GET", 
                "url": config.apiUrl + "/category/" + this.$route.params.cid, 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    this.category = result.data;
                    
                    axios({ 
                        "method": "GET", 
                        "url": config.apiUrl + "/category/" + this.$route.params.cid + "/question", 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            //console.log(result.data);
                            this.loading = false;
                            this.questions = result.data;
                        }, error => {
                            console.error(error);
                            this.loading = false;
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );

                    axios({ 
                        "method": "GET", 
                        "url": config.apiUrl + "/quest", 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            //console.log(result.data);
                            this.loading = false;
                            this.availableQuests = result.data;
                        }, error => {
                            console.error(error);
                            this.loading = false;
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                }, error => {
                    console.error(error);
                    this.loading = false;
                }
            );
        },
        validateItem () {
            let validationError = false;
            if (!this.form.text) {
                validationError = true;
                alert('falta texto de la pregunta');
            }

            if (!validationError) {

                if (this.form.tags) {
                    var t = this.form.tags.map(x => x.text);
                    this.form.tags = t;
                }

                if (this.formForEdit) {
                    axios({ 
                        "method": "PUT", 
                        "url": config.apiUrl + "/category/" + this.$route.params.cid + "/question/" + this.editItemId, 
                        "data": this.form, 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            console.log(result);
                            this.hideForm();
                            this.cleanForm();
                            this.fetchData();
                        }, error => {
                            console.error(error);
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                } else {
                    axios({ 
                        "method": "POST", 
                        "url": config.apiUrl + "/category/" + this.$route.params.cid + "/question", 
                        "data": this.form, 
                        "headers": { "content-type": "application/json", "X-Auth": user.token } }
                    ).then(result => {
                            console.log(result);
                            this.hideForm();
                            this.cleanForm();
                            this.fetchData();
                        }, error => {
                            console.error(error);
                            alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                        }
                    );
                }
            }
        },
        cleanForm () {
            this.form = {
                category: this.$route.params.cid,
                text: null,
                status: null,
                difficulty: null,
                tags: [],
                correct: null,
                incorrect_0: null,
                incorrect_1: null,
                incorrect_2: null,
                incorrect_3: null,
                incorrect_4: null,
                incorrect_5: null,
                incorrect_6: null,
                incorrect_7: null,
                quests: []
            }
            this.formForEdit = false;
            this.editItemId = null;
        },
        showForm () {
            this.showDialog = true;
        },
        hideForm () {
            this.showDialog = false;
        },
        cancelForm () {
            this.hideForm();
            this.cleanForm();
        },
        editItem (item) {
            //console.log(item);
            this.form = {
                category: this.$route.params.cid,
                text: item.text,
                status: item.status,
                difficulty: item.difficulty,
                tags: item.tags,
                correct: item.answers.correct,
                incorrect_0: item.answers.incorrect[0],
                incorrect_1: item.answers.incorrect[1],
                incorrect_2: item.answers.incorrect[2],
                incorrect_3: item.answers.incorrect[3],
                incorrect_4: item.answers.incorrect[4],
                incorrect_5: item.answers.incorrect[5],
                incorrect_6: item.answers.incorrect[6],
                incorrect_7: item.answers.incorrect[7],
                quests: item.quests
            }
            this.formForEdit = true;
            this.editItemId = item.id;
            this.showForm();
        },
        deleteItem (item) {
            this.deleteConfirm = true;
            this.deleteItemId = item.id;
        },
        onDeleteConfirm () {
            axios({ 
                "method": "DELETE", 
                "url": config.apiUrl + "/category/" + this.$route.params.cid + "/question/" + this.deleteItemId, 
                "headers": { "content-type": "application/json", "X-Auth": user.token } }
            ).then(result => {
                    console.log(result);
                    this.fetchData();
                }, error => {
                    console.error(error);
                    alert("Ocurrió un problema en la comunicación con el servidor!\n\n" + error);
                }
            );
        },
        backToCategory (category) {
            this.$router.push('/categories/' + category);
            return false;
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Questions.vue